// Duck-typed cross-store reads of activities-request-proposal's `dealPdfUrl`/`dealPdfVersion`
// (real, typed selectors live in that package's store/selectors.ts). Importing them directly
// would close a circular dependency: activities-request-proposal already imports
// sales-checkin-components. `state: any` and the field names are the only contract here, so
// keep them in sync with RequestProposalState if that shape ever changes.
export const getDealPdfUrl = (state: any): string | undefined => state.requestProposal?.dealPdfUrl;

export const getDealPdfVersion = (state: any): string | undefined => state.requestProposal?.dealPdfVersion;
